import Logger from '../logging/logger';
import { config } from '../../config';

export const checkForNewVersion = (showUpdateAvailable: () => void) => {
    if (config.Environment === 'Local') {
        Logger.information('Running locally - skipping new version check');
        return;
    }

    const browserVersion = extractVersionIdentifier(document.head.innerHTML);
    fetch(window.location.href)
        .then(response => {
            return response.text();
        })
        .then(html => {
            const serverVersion = extractVersionIdentifier(html);
            if (browserVersion !== serverVersion) {
                showUpdateAvailable();
            }
        });
};

export function extractVersionIdentifier(headInnerHTML: string): string | undefined {
    const regExp = /index-([a-zA-Z0-9-]+).js/;
    const matchResult: RegExpMatchArray | null = headInnerHTML.match(regExp);
    return matchResult && matchResult.length > 0 ? matchResult[1] : undefined;
}
